import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { LoginComponentProps } from '../../types/LoginFormData';
import { TSPCategory, TSPConfig } from '../types';

const mylogseldConfig: TSPConfig = {
  key: 'mylogseld',
  name: 'MyLogsELD',
  category: TSPCategory.CUSTOM,
  helpText: 'Input the credentials you use to log into the MyLogsELD portal.',
  loginComponent: (props: LoginComponentProps) => {
    return (
      <LoginCreds
        onValidityChange={props.onValidityChange}
        fields={[
          { label: 'Username', name: 'username', type: 'text', required: true },
          {
            label: 'Password',
            name: 'password',
            type: 'password',
            required: true,
          },
        ]}
      />
    );
  },
};

export default mylogseldConfig;
